import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export interface IDynamicMediaService {
  SMALL_SCREEN_BREAKPOINT: number;
  isScreenSmall: Observable<boolean>;
}


@Injectable({
  providedIn: 'root'
})
export class MediaService implements IDynamicMediaService {

  public readonly SMALL_SCREEN_BREAKPOINT = 720;

  private mediaMatcher: MediaQueryList = matchMedia(`(max-width: ${this.SMALL_SCREEN_BREAKPOINT}px)`);
  private isSmallScreen: BehaviorSubject<boolean>;

  constructor() {
    this.isSmallScreen = new BehaviorSubject<boolean>(this.mediaMatcher.matches);
    this.mediaMatcher.addListener(mql => {
        this.isSmallScreen.next(this.mediaMatcher.matches);
      }
    );
  }


  get isScreenSmall(): Observable<boolean> {
    return this.isSmallScreen.asObservable();
  }
}

